<template>
  <ModalComponent :title="title" :opened="opened" :loading="loading" size="md" @hidden="$emit('hidden')">
    <template #content>
      <MailStatusDetailComponent
        :mailStatus="mailStatus"
        :canUnblock="canUnblock"
        @unblocked="unblocked"
        @loading="(value) => (loading = value)"
      />
    </template>
  </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/ModalComponent.vue";
import MailStatusDetailComponent from "@/components/mailStatus/MailStatusDetailComponent.vue";
import { mailStatusManager } from "@/services/mail-status/mail-status-manager";

export default {
  name: "MailStatusModalComponent",
  components: { ModalComponent, MailStatusDetailComponent },
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    mailStatus: {
      type: Object,
      default: null,
    },
    canUnblock: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["hidden", "unblocked"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    title() {
      return this.$t(mailStatusManager.getTitleKey(this.mailStatus));
    },
  },
  methods: {
    unblocked() {
      this.$emit("unblocked");
      this.$emit("hidden");
    },
  },
};
</script>
